import { Box, type SxProps, type Theme, Tooltip } from "@mui/material";

import { PlacementFilterTooltipContent } from "./TooltipContent";

interface PlacementFilterTooltipProps {
  hasSeenPlacementFilterTooltip: boolean;
  setHasSeenPlacementFilterTooltip: () => void;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export function PlacementFilterTooltip(props: PlacementFilterTooltipProps) {
  const { hasSeenPlacementFilterTooltip, setHasSeenPlacementFilterTooltip, sx, children } = props;
  return (
    <Tooltip
      arrow
      open={!hasSeenPlacementFilterTooltip}
      placement="bottom-end"
      slotProps={{
        popper: {
          disablePortal: true,
        },
        tooltip: {
          sx: {
            backgroundColor: (theme) => theme.palette.primary.main,
            borderRadius: 4,
            padding: 4,
          },
        },
        arrow: {
          sx: {
            color: (theme) => theme.palette.primary.main,
          },
        },
      }}
      title={<PlacementFilterTooltipContent onClose={setHasSeenPlacementFilterTooltip} />}
    >
      <Box component="span" sx={sx}>
        {children}
      </Box>
    </Tooltip>
  );
}
